export const sizes = [
  {
    category: "Lustre Rectangular Prints",
    items: [
      { label: "Wallet (15.24x10.16cm) Lustre", price: 1.50, widthIn: 6, heightIn: 4 },
      { label: "3.5x5 (9x13cm) Lustre", price: 1.00, widthIn: 3.5, heightIn: 5 },
      { label: "6x4 (15x10cm) Lustre", price: 1.00, widthIn: 6, heightIn: 4 },
      { label: "5x7 (12.7x17.78cm) Lustre", price: 3.95, widthIn: 5, heightIn: 7 },
      { label: "6x8 (15.24x20.32cm) Lustre", price: 5.95, widthIn: 6, heightIn: 8 },
      { label: "8x10 (20.32x25.4cm) Lustre", price: 12.95, widthIn: 8, heightIn: 10 },
      { label: "8x12 (20.32x30.48cm) Lustre Print", price: 14.95, widthIn: 8, heightIn: 12 },
      { label: "A4 (21x29.7cm)  Lutre Prints", price: 15, widthIn: 8.3, heightIn: 11.7 },
    ],
  },
  {
    category: "Glossy Rectangular Prints",
    items: [
      { label: "Wallet (15.24x10.16cm) Gloss", price: 1.50, widthIn: 6, heightIn: 4 },
      { label: "3.5x5 (9x13cm) Gloss", price: 1.00, widthIn: 3.5, heightIn: 5 },
      { label: "6x4 (15x10cm) Gloss", price: 1.00, widthIn: 6, heightIn: 4 },
      { label: "5x7 (12.7x17.78cm) Gloss", price: 3.95, widthIn: 5, heightIn: 7 },
      { label: "6x8 (15.24x20.32cm) Gloss", price: 5.95, widthIn: 5, heightIn: 8 },
    ],
  },
  {
    category: "Square Lustre Prints",
    items: [
      { label: "4x4 (10.16x10.16cm) Lustre", price: 1.00, widthIn: 4, heightIn: 4 },
      { label: "5x5 (12.7x12.7cm) Lustre", price: 3.95, widthIn: 5, heightIn: 5 },
      { label: "6x6 (15.24x15.24cm) Lustre", price: 19.99, widthIn: 20, heightIn: 30 },
      { label: "8x8 (20.32x20.32cm) Lustre", price: 12.95, widthIn: 8, heightIn: 8 },
      { label: "10x10 (25.4x25.4cm) Lustre", price: 18.95, widthIn: 10, heightIn: 10 },
      { label: "12x12 (30.48x30.48cm) Lustre", price: 23.95, widthIn: 12, heightIn: 12 },
    ],
  },
  {
    category: "Enlargements",
    items: [
      { label: "11x14 (27.94x35.56cm)", price: 19.95, widthIn: 11, heightIn: 14 },
      { label: "10x15 (25.4x38.1cm)", price: 19.95, widthIn: 10, heightIn: 15 },
      { label: "12x16 (30.48x40.64cm)", price: 24.95, widthIn: 12, heightIn: 16 },
      { label: "12x18 (30.48x45.72cm)", price: 24.95, widthIn: 12, heightIn: 18 },
      { label: "A3 (29.72x41.91cm) Lustre", price: 24.95, widthIn: 11.7, heightIn: 16.5 },
      { label: "16x20 (40.64x50.8cm)", price: 39.95, widthIn: 16, heightIn: 20 },
      { label: "16x24 (40.64x60.96cm)", price: 39.95, widthIn: 16, heightIn: 24 },
      { label: "A2 (42x59.4cm)", price: 45.00, widthIn: 16.53, heightIn: 23.39 },
      { label: "18x24 (45.72x60.96cm)", price: 45.00, widthIn: 18, heightIn: 24 },
      { label: "20x24 (50.8x60.96cm)", price: 59.95, widthIn: 20, heightIn: 24 },
      { label: "20x30 (50.8x76.2cm)", price: 69.95, widthIn: 20, heightIn: 30 },
      { label: "24x36 (60.96x91.44cm)", price: 85.00, widthIn: 24, heightIn: 36 },
      { label: "30x40 (76.2x101.6cm)", price: 140.00, widthIn: 30, heightIn: 40 },
      { label: "40x60 (101.6x152.4cm)", price: 230.00, widthIn: 40, heightIn: 60 },
    ],
  },
  {
    category: "Panoramic",
    items: [
      { label: "4x8 (10.16x20.32cm)", price: 3.50, widthIn: 4, heightIn: 8 },
      { label: "4x10 (10.16x25.4cm)", price: 4.50, widthIn: 4, heightIn: 10 },
      { label: "4x12 (10.16x30.48cm)", price: 5.00, widthIn: 4, heightIn: 12 },
      { label: "4x16 (10.16x40.64cm)", price: 15.00, widthIn: 4, heightIn: 16 },
      { label: "4x20 (10.16x50.8cm)", price: 16.00, widthIn: 4, heightIn: 20 },
      { label: "4x24 (10.16x60.96cm)", price: 19.00, widthIn: 4, heightIn: 16 },
      { label: "4x32 (10.16x81.28cm)", price: 22.00, widthIn: 4, heightIn: 32 },
      { label: "6x12 (15.24x30.48cm)", price: 8.95, widthIn: 6, heightIn: 12 },
      { label: "6x18 (15.24x45.72cm)", price: 19.95, widthIn: 6, heightIn: 18 },
      { label: "6x24 (15.24x60.96cm)", price: 25.00, widthIn: 6, heightIn: 24 },
      { label: "6x30 (15.24x76.2cm)", price: 62.00, widthIn: 6, heightIn: 30 },
      { label: "6x36 (15.24x91.44cm)", price: 32.00, widthIn: 6, heightIn: 36 },
      { label: "6x48 (15.24x121.92cm)", price: 38.00, widthIn: 6, heightIn: 48 },
      { label: "8x16 (20.32x40.64cm)", price: 20.00, widthIn: 8, heightIn: 16 },
      { label: "8x20 (20.32x50.8cm)", price: 24.00, widthIn: 8, heightIn: 20 },
      { label: "8x24 (20.32x60.96cm)", price: 28.00, widthIn: 8, heightIn: 24 },
      { label: "8x32 (20.32x81.28cm)", price: 35.00, widthIn: 8, heightIn: 32 },
      { label: "8x40 (20.32x101.6cm)", price: 38.00, widthIn: 8, heightIn: 40 },
      { label: "8x48 (20.32x121.92cm)", price: 45.00, widthIn: 8, heightIn: 48 },
      { label: "10x20 (25.4x50.8cm)", price: 26.00, widthIn: 10, heightIn: 20 },
      { label: "10x30 (25.4x76.2cm)", price: 39.00, widthIn: 10, heightIn: 30 },
      { label: "10x40 (25.4x101.6cm)", price: 49.00, widthIn: 10, heightIn: 40 },
      { label: "12x24 (30.48x60.96cm)", price: 36.00, widthIn: 12, heightIn: 24 },
      { label: "12x36 (30.48x91.44cm)", price: 49.00, widthIn: 12, heightIn: 36 },
      { label: "12x48 (30.48x121.92cm)", price: 65.00, widthIn: 12, heightIn: 48 },
      { label: "16x32 (40.64x81.28cm)", price: 55.00, widthIn: 16, heightIn: 32 },
      { label: "16x48 (40.64x121.92cm)", price: 75.00, widthIn: 16, heightIn: 48 },
      { label: "18x36 (45.72x91.44cm)", price: 60.00, widthIn: 18, heightIn: 36 },
      { label: "18x54 (45.72x137.16cm)", price: 85.00, widthIn: 18, heightIn: 54 },
      { label: "20x40 (50.8x101.6cm)", price: 70.00, widthIn: 20, heightIn: 40 },
      { label: "20x60 (50.8x152.4cm)", price: 99.00, widthIn: 20, heightIn: 60 },
      { label: "24x48 (60.96x121.92cm)", price: 90.00, widthIn: 24, heightIn: 48 },
      { label: "24x60 (60.96x152.4cm)", price: 110.00, widthIn: 24, heightIn: 60 },
      { label: "24x72 (60.96x182.88cm)", price: 125.00, widthIn: 24, heightIn: 72 },
    ],
  },
];